module.exports = __webpack_public_path__ + "static/payouts-background-cc186d8e919a73e4dba6619580118ddf.png";